import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { SerieService } from "../shared";

@Component({
  selector: "serie-list",
  templateUrl: "./serie-list.component.html",
  styleUrls: ["./serie-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class SerieListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: SerieService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Series - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/serie-list/serie-list.component.ts